import Tooltip from '@mui/material/Tooltip';
import { UnifiedStudy } from '../types';
import { dateFormatFn, DownloadFile } from '../utils/utils';
import { WebEntity } from './types';
import { useNavigate } from 'react-router-dom';

const StudiesEntity: WebEntity<UnifiedStudy> = {
  name: 'studies',
  endpoint: 'estudios/myStudies',
  referenceColumn: 'nombre',
  tableColumns: [
    {
      header: 'ID',
      accessorKey: '_id',
      omitExport: true,
      columnType: 'text',
      enableHiding: false,
      visibleInShowHideMenu: false
    },
    {
      header: 'Nombre',
      accessorKey: 'nombre',
      columnType: 'text',
      size: 118
    },
    {
      header: 'Tipo de Estudio',
      accessorKey: 'tipoEstudio',
      columnType: 'text',
      size: 115
    },
    {
      header: 'Visibilidad',
      accessorKey: 'visibilidad',
      columnType: 'text',
      size: 96
    },
    {
      header: 'Alimentador',
      accessorKey: 'alimentadorNombre',
      columnType: 'text',
      size: 115
    },
    {
      header: 'Fecha',
      accessorKey: 'createdAt',
      columnType: 'dateUTC',
      size: 92,
      Cell: ({ row }) => dateFormatFn(row?.original?.createdAt, 'DD/MM/YYYY', true)
    },
    {
      header: 'Estado',
      accessorKey: 'estado',
      columnType: 'text',
      size: 90
    },
    {
      header: 'Mitigación',
      accessorKey: 'estadoMitigacion',
      columnType: 'text',
      size: 92,
      Cell: ({ row }) => {
        const val = row.original?.estadoMitigacion;
        return val || '—';
      }
    },
    {
      header: 'Ver',
      accessorKey: 'ver' as any,
      columnType: 'text',
      omitExport: true,
      size: 126,
      Cell: ({ row }) => {
        const navigate = useNavigate();
        const orig = row.original;
        if (!orig) return null;

        const isTerminal = orig.estado === 'Finalizada' || orig.estado === 'Error';

        if (orig.tablaOrigen === 'estudio_conexion_gd') {
          const mitigacionFinalizada = orig.estadoMitigacion === 'Finalizada';
          const tooltipMitigacion = !orig.estadoMitigacion
            ? 'Mitigación no ejecutada'
            : `Mitigación: ${orig.estadoMitigacion}`;

          return (
            <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'center', alignItems: 'center' }}>
              <Tooltip title='Ver resultados del estudio base' arrow>
                <button
                  type='button'
                  className='vdr-gen-link'
                  onClick={() => navigate(`/private/estudio-conexion/${orig._id}/resultado`)}>
                  Base
                </button>
              </Tooltip>
              <span style={{ color: 'var(--vdr-line-strong)', userSelect: 'none' }} aria-hidden='true'>
                |
              </span>
              <Tooltip title={mitigacionFinalizada ? 'Ver resultados de mitigación' : tooltipMitigacion} arrow>
                {/* El span deja ver el tooltip también cuando el botón está deshabilitado. */}
                <span className='vdr-gen-link-wrap'>
                  <button
                    type='button'
                    className='vdr-gen-link'
                    disabled={!mitigacionFinalizada}
                    onClick={
                      mitigacionFinalizada
                        ? () => navigate(`/private/estudio-conexion/${orig._id}/resultado-mitigacion`)
                        : undefined
                    }>
                    Mitigación
                  </button>
                </span>
              </Tooltip>
            </div>
          );
        }

        if (orig.tablaOrigen === 'simulacion' && isTerminal) {
          return (
            <button
              type='button'
              className='vdr-gen-link'
              onClick={() => navigate(`/private/resultado-estudio/${orig._id}`)}>
              Ver resultado
            </button>
          );
        }
        return null;
      }
    },
    {
      header: 'Descargar',
      accessorKey: 'descargar' as any,
      columnType: 'text',
      omitExport: true,
      size: 100,
      Cell: ({ row }) => {
        const orig = row.original;
        if (
          orig?.tablaOrigen === 'simulacion' &&
          orig?.estado === 'Finalizada' &&
          orig?.archivoResultado
        ) {
          return (
            <DownloadFile
              fileName={orig.archivoResultado}
              fileType='application/pdf'
              buttonName='Descargar reporte'
              endpoint='estudios/downloadReport'
            />
          );
        }
        return null;
      }
    }
  ]
};

export default StudiesEntity;
